import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/gerenciamento-medico`

    return {
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        reschedule(params) {
            return repository.put(`${baseUrl}/reschedule`, params)
        },
        cancel(params) {
            return repository.put(`${baseUrl}/cancel`, params)
        },
    }
}